import React from 'react';
import {useTranslation} from "react-i18next";
import CustomButton from "../../../components/UI/customButton/customButton";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {SuccessIcon} from "../../../icons/icons";

const SuccessPage = ({activeStep , changeStep}) => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const user = useSelector((state) => state.user.user)
  const [param] = useSearchParams()
    const handleNavigation = () => {
      if(user?.role_key === "super_admin") {
        changeStep(7)
      } else {
        navigate("/")
      }
  }
  return (
    <div className={`my-container ${activeStep ? "h-auto" :"h-0 overflow-hidden "}`}>
      <div className={" relative bg-white rounded-lg  flex flex-col items-center gap-5 md:gap-9 w-full !mt-20 py-5 md:py-10 px-4 md:px-[13%] mb-8"}>
        <SuccessIcon/>
        <span className={"text-lg md:text-2xl text-primary-400 font-medium"}>{t("successfulPayment")}</span>
        <span className={"md:w-1/2 2xl:w-full text-sm md:text-base text-center leading-8 text-gray-500 font-light md:font-semibold"}>{t("trackingNumber") + " : " + param?.get('trackId')}</span>
        <span className={"md:w-1/2 2xl:w-full text-sm md:text-base text-center leading-8 text-gray-500 font-light md:font-light"}>{t("successfulPaymentDes")}</span>
        <div className={"w-[330px]"}>
          <CustomButton onClick={() => handleNavigation()} title={ "understand"}/>
        </div>
      </div>
      </div>
  );
};

export default SuccessPage;
